import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

export interface ToolbarFilter {
  key: string;
  label: string;
  value?: string;
  icon?: string;
  options?: string[];
}

@Component({
  selector: 'app-page-toolbar',
  standalone: false,
  templateUrl: './page-toolbar.component.html',
  styleUrls: ['./page-toolbar.component.scss'],
})
export class PageToolbarComponent implements OnInit, OnDestroy {
  @Input() searchPlaceholder: string = 'Search...';
  @Input() searchValue: string = '';
  @Input() filters: ToolbarFilter[] = [];
  @Input() rightText?: string;
  @Input() searchDebounce: number = 600;

  @Output() searchChange = new EventEmitter<string>();
  @Output() filterClick = new EventEmitter<ToolbarFilter>();
  @Output() filterChange = new EventEmitter<ToolbarFilter>();

  private _searchInput$ = new Subject<string>();
  private _sub!: Subscription;

  ngOnInit(): void {
    this._sub = this._searchInput$
      .pipe(debounceTime(this.searchDebounce), distinctUntilChanged())
      .subscribe((value) => this.searchChange.emit(value));
  }

  ngOnDestroy(): void {
    this._sub.unsubscribe();
  }

  onSearch(value: string): void {
    this._searchInput$.next(value);
  }

  onFilterClick(filter: ToolbarFilter): void {
    this.filterClick.emit(filter);
  }

  onFilterSelect(filter: ToolbarFilter, value: string): void {
    filter.value = value;
    this.filterChange.emit(filter);
  }
}